module.exports = __webpack_public_path__ + "996736fbbee4c63e6f3eb3a18303f04e.pdf";